import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "../pages/Home/Home";
//import Header from "../Components/Header";
import Footer from "../Components/Footer/Footer";

import Thanks from "../pages/Thanks/Thanks";
import { AnimatePresence } from "framer-motion";
import WhyMomentumHome from "../pages/WhyMomentum/WhyMomentumHome";
import SolarPlusStorageHome from "../pages/SolarPlusStorage/SolarPlusStorageHome";
import Accolades from "../pages/Accolades/Accolades";
import Referral from "../pages/Referral/Referral";
import OurWork from "../pages/OurWork/OurWork";
import WhySolarHome from "../pages/WhySolar/WhySolarHome/WhySolarHome";

const AppRouter = (props) => {
  return (
    <Router>
      {/* <Wrapper> */}

      <AnimatePresence exitBeforeEnter>
        <Switch>
          <Route exact path={["/home"]}>
            <Home />
          </Route>

          <Route exact path={"/whymomentum"}>
            <WhyMomentumHome />
          </Route>

          <Route exact path={"/solarplusstorage"}>
            <SolarPlusStorageHome />
          </Route>

          <Route exact path={"/whysolar"}>
            <WhySolarHome />
          </Route>

          <Route exact path={"/accolades"}>
            <Accolades />
          </Route>
          <Route exact path={"/referral"}>
            <Referral />
          </Route>
          <Route exact path={"/ourwork"}>
            <OurWork />
          </Route>

          <Route path={"/thanks"}>
            <Thanks />
          </Route>
        </Switch>
      </AnimatePresence>
      <Footer />
      {/* </Wrapper> */}
    </Router>
  );
};

// const Wrapper = ({ children }) => {
//   let { id } = useParams();
//   console.log(id);
//   const { setInfo } = useContext(Context);

//   const { data, error, loading } = useQuery(GET_BATTERY_APPOINTMENT, {
//     variables: {
//       _id: id,
//     },
//   });
//   useEffect(() => {
//     if (data) {
//       console.log(info);
//       console.log(data);
//       const info = data.allBatteryProposalsByUnique[0];

//       setInfo(info);
//     }
//   }, [data]);
//   if (error || loading) return "ss";

//   return children;
// };

// const MyRoute = ({ component: Component, to, ...rest }) => {
//   console.log(Component, to);
//   return (
//     <Route {...rest} exact path={to}>
//       <Component />
//     </Route>
//   );
// };

export default AppRouter;
